import { createPinia } from 'pinia'
import {
  configCsrfToAxios,
  initializeInstances
} from '@shared/services/initializer.js'

export class Initializer {
  constructor() {
    this.vueApps = []
    this.pinia = createPinia()
    this.start()
  }

  async start() {
    configCsrfToAxios()

    initializeInstances({
      pinia: this.pinia,
      vueApps: this.vueApps,
      importInitializer: (vueName) => import(`./initializers/${vueName}.js`)
    })
  }
}

export default Initializer
